import React from 'react';
import ReactTooltip from 'react-tooltip';
import { palette } from 'src/styles/colors';
import { MightyExclusiveTagContainer, StarImageContainer } from './tag.mightyExclusive.styles';

const MightyExclusive = (): JSX.Element => {
  return (
    <React.Fragment>
      <ReactTooltip />
      <MightyExclusiveTagContainer>
        <span>MIGHTY EXCLUSIVE</span>
      </MightyExclusiveTagContainer>
      <StarImageContainer data-tip="Mighty Exclusive">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.26005 15.1907C3.77121 15.4477 3.16658 15.2597 2.90958 14.7709C2.80724 14.5762 2.77192 14.3533 2.8091 14.1365L3.51202 10.0382L0.534411 7.13572C0.138927 6.75022 0.130835 6.11711 0.516336 5.72162C0.669845 5.56414 0.870987 5.46165 1.08862 5.43003L5.20358 4.83209L7.04384 1.10331C7.28826 0.608058 7.88789 0.404719 8.38314 0.649141C8.58035 0.746471 8.73998 0.906099 8.83731 1.10331L10.6776 4.83209L14.7925 5.43003C15.3391 5.50945 15.7178 6.01689 15.6383 6.56343C15.6067 6.78107 15.5042 6.98221 15.3467 7.13572L12.3691 10.0382L13.072 14.1365C13.1654 14.6808 12.7998 15.1978 12.2555 15.2911C12.0387 15.3283 11.8158 15.293 11.6211 15.1907L7.94057 13.2557L4.26005 15.1907Z" fill={palette.snowFlower}/>
        </svg>
      </StarImageContainer>
    </React.Fragment>
  )
}

export default MightyExclusive;
